import gql from 'graphql-tag';

export default {
  getMyCampaigns: gql`
    fragment FlyerTitle_getMyCampaigns on Campaign {
      title
    }
  `,
};
